import React from "react";
var __jsx = React.createElement;
import UserIcon from "../common/UserIcon";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useAuth } from "@qure/qure-auth";
import { getUserName } from "../../utils";
var UserBio = function UserBio(props) {
  var onLogout = props.onLogout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var user = get(userInfo, ["details"], null);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex sm:hidden items-center justify-between p-4 border-b border-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement(UserIcon, {
    name: getUserName(user),
    className: "h-8 w-8 text-lg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-center ml-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-base break-all"
  }, getUserName(user)), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-400 break-all"
  }, get(user, ["email"], "")), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-400 break-all"
  }, get(user, ["phone"], "")))), /*#__PURE__*/React.createElement("div", {
    className: "flex whitespace-nowrap text-gray-500 text-md font-bold py-3"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onLogout
  }, t("logout_key"))));
};
export default UserBio;